import React, { useState } from 'react';
import { getData, saveDataIntoAsyncStore } from '../utils/commons';
import i18n from '../translations/i18n';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { Grid, Box, Typography, Button } from '@mui/material';
import theme from '../theme.css';
import { portalCfg } from '../config';
import { Link } from 'react-router-dom';
import { paths } from '../config/router.config';

const backgroudImage = portalCfg.publicPath + "/images/background.jpg";

const useStyles = makeStyles((theme) => ({
    container: {
        padding: '3%',
        display: 'flex',
        height: "100%",
        background: 'url(' + backgroudImage + ')',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
    },
    logo: {
        height: theme.spacing(20),
        [theme.breakpoints.down('xl')]: {
            height: theme.spacing(15),
        },
        [theme.breakpoints.down('lg')]: {
            height: theme.spacing(10),
        },
        [theme.breakpoints.down('md')]: {
            height: theme.spacing(15),
        },
    },
    left: {
        [theme.breakpoints.down('lg')]: {
            display: 'none'
        },
        display: 'flex',
        height: "100%",
        justifyContent: 'center',
        alignItems: 'center'
    },
    right: {
        borderRadius: 10,
        background: theme.palette.common.white,
    },
    right_box: {
        padding: '5%',
    },
    link:{
        textDecoration: 'none',
        color: theme.palette.text.link,
    },
}));


export default function PublicPage(props) {
    const { t } = useTranslation();
    const classes = useStyles();
    const [language, setLanguage] = useState(getData('LANGUAGE'));

    const changeLanguage = () => {
        let lang = '';
        if (language == 'ENG') {
            lang = 'ELL';
        } else {
            lang = 'ENG';
        }
        setLanguage(lang);
        saveDataIntoAsyncStore('LANGUAGE', lang);
        i18n.changeLanguage(lang);
    }

    const { rightComponent } = props;
    return (
        <Grid item xs={12} className={classes.container} container direction="row" justifyContent="center" alignContent="center">
            <Grid item xs={12} md={7} lg={5} xl={3} className={classes.right}>
                <Grid item xs={12} className={classes.right_box}>
                    <Link to={"/"} className={classes.link} fullWidth={true}>
                        <Box style={{ textAlign: 'center' }}>
                            <img src="/images/logo1.png" alt="Logo" className={classes.logo}></img>
                        </Box>
                    </Link>

                    {rightComponent}
                    {/* <Box margin={5}>
                        <Button variant="text" fullWidth onClick={()=> changeLanguage()}>
                            {language && language == 'ENG' ? t('languageGR') : t('languageEnglish')}
                        </Button>
                    </Box> */}
                </Grid>
            </Grid>
        </Grid>
    );
}